// eslint-disable-next-line
export default path => window.location = path;
